import { Descriptor } from "hooks/intl";
import { BEWalletTypeFormat } from "types/wallets";
import { monthNames } from "utilities/dateFormat";

export const getExpirationPeriod = ({
  walletDetails,
  message,
}: {
  walletDetails?: BEWalletTypeFormat;
  message: (
    { id, defaultMessage, description }: Descriptor,
    values?: any,
    opts?: any,
  ) => string;
}) => {
  if (!walletDetails) return;
  switch (walletDetails.unitDaysExpiryAfter) {
    case "all_time_active":
      return message({ id: "noExpiration" });
    case "after_x_days":
      return message(
        { id: "afterNDays" },
        {
          count: walletDetails.unitDaysActiveCount,
        },
      );
    case "at_the_end_of_the_month":
      return message({ id: "atTheEndOfTheMonth" });
    case "at_the_end_of_the_x_th_year":
      if (walletDetails.unitYearsActiveCount === 0) {
        return message({ id: "atTheEndOfThisYear" });
      }
      return message(
        { id: "afterNYears" },
        {
          count: walletDetails.unitYearsActiveCount,
        },
      );
    case "at_the_end_of_the_chosen_date":
      const [month, day] = (walletDetails.unitExpiryDate || "").split("-");
      const monthName = monthNames[Number(month) - 1];

      return `${message({ id: "expiresAnnually" })}: ${day} ${message({ id: monthName })}`;
  }
};

export type Interval = {
  type:
    | "calendarHours"
    | "calendarDays"
    | "calendarWeeks"
    | "calendarMonths"
    | "calendarYears"
    | "inTotal";
  value?: number;
};

export const getLimitPeriod = ({
  interval,
  message,
}: {
  interval: Interval;
  message: (
    { id, defaultMessage, description }: Descriptor,
    values?: any,
    opts?: any,
  ) => string;
}) => {
  switch (interval.type) {
    case "calendarHours":
      return `${interval.value} ${message({ id: "perHour" })}`;
    case "calendarDays":
      return `${interval.value} ${message({ id: "perDay" })}`;
    case "calendarWeeks":
      return `${interval.value} ${message({ id: "perWeek" })}`;
    case "calendarMonths":
      return `${interval.value} ${message({ id: "perMonth" })}`;
    case "calendarYears":
      return `${interval.value} ${message({ id: "perYear" })}`;
    case "inTotal":
      return `${interval.value} ${message({ id: "inTotal" })}`;
  }
};
